import request from '../http';

export const getFacebookPopupAuthUrl = () =>
  request({ url: '/meta/facebook/authorize/popup', method: 'get' });

export const facebookBind = (code, popup = true) =>
  request({ url: '/meta/facebook/bind', method: 'post', params: { code, popup } });

export const facebookBindByToken = (token, tokenName, tokenType, adAccountId) =>
  request({
    url: '/meta/facebook/bind/token',
    method: 'post',
    data: { token, tokenName, tokenType, adAccountId }
  });

export const facebookUnbind = () =>
  request({ url: '/meta/facebook/unbind', method: 'post' });

export const getFacebookBindingStatus = () =>
  request({ url: '/meta/facebook/status', method: 'get' });

export const getUserFacebookAccounts = () =>
  request({ url: '/meta/facebook/accounts', method: 'get' });

export const setPrimaryAccount = (tokenId) =>
  request({ url: `/meta/facebook/accounts/${tokenId}/primary`, method: 'put' });

export const deleteFacebookAccount = (tokenId) =>
  request({ url: `/meta/facebook/accounts/${tokenId}`, method: 'delete' });

export const updateTokenName = (tokenId, tokenName) =>
  request({ url: `/meta/facebook/accounts/${tokenId}/name`, method: 'put', data: { tokenName } });

export const refreshBmAccounts = (tokenId) =>
  request({ url: '/meta/facebook/refresh-bm', method: 'post', params: { tokenId } });
